import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { audioInterface } from '../audio-player.component';

@Injectable({
  providedIn: 'root'
})
export class AudioPlayerService {
  PalyedAudioInfo = new BehaviorSubject<audioInterface | null>(null);
  constructor() { }
  get getPalyedAudioInfo() {
    return this.PalyedAudioInfo.value;
  }

  get haveAudio() {
    return !this.PalyedAudioInfo.value;
  }

  setAudio(data: any) {
    this.PalyedAudioInfo.next(data);
  }
}
